<style>
th:first-child {
  width: 10px;
}

/* custom-search */
.custom-search .v-text-field__slot input {
  border-bottom: none !important;
  padding: 5px 12px !important;
  margin: 0 !important;
}

.custom-search .v-label {
  padding: 0 12px;
  top: 12px;
}

.custom-search .v-text-field__slot input:focus {
  border-bottom: none !important;
  box-shadow: none !important;
}
.del:hover {
  color: #000 !important;
}
</style>

<template lang="pug">
div
  .row
    .col.s12
      router-link.waves-effect.waves-teal.btn(:to='{ name: "products-upload" }')
        | Upload
        i.material-icons.right file_upload
      | &nbsp;
      a.waves-effect.btn.grey.lighten-5.black-text.del(
        @click='addNewProduct'
      ) Add Item to SAP
      | &nbsp;
      a.waves-effect.btn.grey.lighten-5.black-text.del(
        v-if='selected.length',
        @click='confirmDelete'
      ) Delete

  .row
    .col.s12
      v-app
        v-card
          v-card-title
            v-layout.justify-space-between.align-center.wrap
              v-flex.sm7
              v-flex.sm5
                v-spacer
                v-text-field.custom-search(
                  v-model='search',
                  append-icon='search',
                  label='Search',
                  single-line='',
                  hide-details=''
                )
          v-card-text
            v-data-table(
              v-model='selected',
              :headers='headers',
              :items='products',
              :search='search',
              select-all,
              v-if='products.length'
            )
              template(slot='items', slot-scope='props')
                tr(
                  :active='props.selected',
                  @click='props.selected = !props.selected'
                )
                  td
                    v-checkbox(
                      :input-value='props.selected',
                      primary,
                      hide-details
                    )
                  td
                    a(href='#', @click='viewProduct(props.item)') {{ props.item.name }}
                  td {{ props.item.productCode }}
                  td {{ props.item.category }}
                  td {{ props.item.tags }}
              v-alert(
                slot='no-results',
                :value='true',
                color='red',
                icon='warning'
              )
                | Your search for &quot;{{ search }}&quot; found no results.

            p.subtitle.medium(v-else) You haven't uploaded any products yet
</template>
<script>
import AppProductDetails from '@/components/app-product-details'
import AppProductAddNew from '@/components/app-product-add-new'
import AlertModalContent from 'inomph-common/dist/components/alert-modal-content'

export default {
  meta: {
    title: 'Products'
  },
  data () {
    return {
      modal: null,
      products: [],
      productSelection: [],
      headers: [
        { text: 'Name', value: 'name', align: 'left' },
        { text: 'Code', value: 'productCode', align: 'left' },
        { text: 'Category', value: 'category', align: 'left' },
        { text: 'Tags', value: 'tags', align: 'left' }
      ],
      search: '',
      selected: [],
      singleSelect: false
    }
  },
  mounted () {
    this.getProducts()
  },
  computed: {
    supplier () {
      return this.$store.state.profile.supplier
    }
  },
  watch: {
    supplier () {
      this.getProducts()
    }
  },
  methods: {
    selectAll (selectAll) {
      if (selectAll) {
        this.productSelection = (this.products || []).map(
          (product) => product.id
        )
      } else {
        this.productSelection = []
      }
    },
    viewProduct (product) {
      const modalParams = {
        content: AppProductDetails,
        style: { padding: 'medium' },
        bind: {
          product: product,
          onNewPSuccess: () => {
            this.$snackbar.success('Products successfully added!')
            this.getProducts()
            this.$store.dispatch('modal/close')
          },
          onNewPFailed: (err) => {
            this.$snackbar.error(err.message)
            this.getProducts()
            this.$store.dispatch('modal/close')
          }
        }
      }
      this.$store.dispatch('modal/open', modalParams)
    },
    addNewProduct () {
      const modalParams = {
        content: AppProductAddNew,
        style: { padding: 'medium' },
        bind: {
          // product: product,
          onNewPSuccess: () => {
            this.$snackbar.success('Products successfully added!')
            this.getProducts()
            this.$store.dispatch('modal/close')
          },
          onNewPFailed: (err) => {
            this.$snackbar.error(err.message)
            this.getProducts()
            this.$store.dispatch('modal/close')
          }
        }
      }
      this.$store.dispatch('modal/open', modalParams)
    },
    // showviewProduct (product) {
    //   const modalParams = {
    //     content: AppProductDetails,
    //     bind: {
    //       product: product,
    //       onNewPSuccess: () => {
    //         this.$snackbar.success('discount added')
    //       },
    //       onNewPFailed: (err) => {
    //         this.$snackbar.error(err.message)
    //       }
    //     },
    //     style: {
    //       padding: 'medium'
    //     }
    //   }
    //   this.$store.dispatch('modal/open', modalParams)
    // },
    getProducts () {
      if (!this.supplier) {
        return
      }
      this.$store.dispatch('auth/getAccessToken').then((accessToken) => {
        return this.$http
          .get(
            `${this.$config.API_URL}/suppliers/${this.supplier.code}/products`,
            // `${this.$config.API_URL}/suppliers/1/products`,
            {
              headers: {
                Authorization: 'Bearer ' + accessToken
              }
            }
          )
          .then((result) => {
            this.products = result.data
          })
      })
    },
    confirmDelete () {
      const modalParams = {
        content: AlertModalContent,
        style: { padding: 'medium' },
        bind: {
          title: `Delete ${this.selected.length} product/s?`,
          message: 'This cannot be undone.',
          positiveButton: {
            message: 'Delete',
            onClick: this.deleteSelectedProducts.bind(this)
          },
          negativeButton: {
            message: 'Cancel',
            onClick: () => {
              this.modal.close()
            }
          }
        }
      }

      this.$store.dispatch('modal/open', modalParams).then((modal) => {
        this.modal = modal
      })
    },
    deleteSelectedProducts () {
      this.$store.dispatch('auth/getAccessToken').then((accessToken) => {
        const deletion = this.selected.map((product) => {
          return this.$http.delete(
            `${this.$config.API_URL}/suppliers/${this.supplier.code}/products/${product.id}`,
            {
              headers: {
                Authorization: `Bearer ${accessToken}`
              }
            }
          )
        })
        return Promise.all(deletion)
          .then(() => {
            this.$snackbar.success('Products deleted successfully')
            this.modal.close()
          })
          .catch((err) => {
            if (err.response.status < 500) {
              this.$snackbar.error(
                'Unable to delete products: ' + err.response.data.message
              )
            } else {
              this.$snackbar.error(
                'Unknown error occurred while trying to delete the products'
              )
            }
            this.modal.close()
          })
          .then(() => {
            this.productSelection = []
            this.getProducts()
          })
      })
    },
    toggleAll () {
      if (this.selected.length) this.selected = []
      else this.selected = this.products.slice()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/page-products-list.vue